import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { X, BookOpen } from "lucide-react";
import { trackEvent } from "@/utils/tracking";

const KEY = "nalura_lead_popup_v1";
const COVER = "https://static.prod-images.emergentagent.com/jobs/34a06e80-8bfb-46bf-a2ac-7e5393b6be5e/images/4ada30e57348d136c3d33e4c1d5e32a60f1417b805dcf5a654430e15ac62fa01.jpeg";

export const LeadPopup = ({ enableTimer = false }) => {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;

    const show = () => {
      if (shownRef.current || localStorage.getItem(KEY)) return;
      shownRef.current = true;
      localStorage.setItem(KEY, "1");
      setOpen(true);
      trackEvent("popup_lead_magnet_shown", {});
    };

    const onMouseOut = (e) => {
      if (!e.relatedTarget && e.clientY <= 0) show();
    };
    const onScroll = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.5) show();
    };
    document.addEventListener("mouseout", onMouseOut);
    window.addEventListener("scroll", onScroll, { passive: true });
    let timer;
    if (enableTimer) timer = setTimeout(show, 20000);

    return () => {
      document.removeEventListener("mouseout", onMouseOut);
      window.removeEventListener("scroll", onScroll);
      if (timer) clearTimeout(timer);
    };
  }, [enableTimer]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
        trackEvent("popup_closed", {});
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  if (!open) return null;

  const close = () => {
    setOpen(false);
    trackEvent("popup_closed", {});
  };
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center px-5" data-testid="lead-popup" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-[#211B10]/50 backdrop-blur-sm" onClick={close} aria-hidden="true" />
      <div className="relative bg-[#FBF7EE] border border-[#A67C1E]/30 max-w-md w-full p-8 md:p-10 shadow-2xl">
        <button
          data-testid="lead-popup-close"
          onClick={close}
          aria-label="Tutup"
          className="absolute top-3 right-3 p-3 text-[#211B10]/60 hover:text-[#211B10] transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
        <div className="flex items-start gap-5">
          <img src={COVER} alt="E-book 7 Kebiasaan Good Mind untuk Uang" className="w-20 border border-[#211B10]/10 shrink-0 hidden sm:block" />
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#A67C1E] mb-3">Gratis untuk Anda</p>
            <p className="font-display text-2xl tracking-tight leading-snug mb-3">
              E-book <em className="text-[#A67C1E]">7 Kebiasaan Good Mind untuk Uang</em>
            </p>
            <p className="text-sm text-[#211B10]/65 leading-relaxed mb-6">
              Tujuh kebiasaan kecil, 5-10 menit sehari, untuk pikiran yang lebih tenang dan keputusan uang yang lebih jernih. Unduh gratis.
            </p>
            <Link
              to="/gratis?sumber=popup"
              data-testid="lead-popup-cta"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 bg-[#A67C1E] text-[#FBF7EE] font-medium text-xs uppercase tracking-[0.12em] px-6 py-3.5 hover:bg-[#211B10] transition-colors duration-300"
            >
              <BookOpen className="w-4 h-4" /> Ambil Panduan Gratis
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
